import { IOdataFilter } from './IOdataFilter';
import { IOdataField } from '../Field/IOdataField';

export class OdataFilterCompare implements IOdataFilter {
  private field1: IOdataField;
  private field2: IOdataField;
  private compare: OdataFilterCompareType;

  constructor(left: IOdataField, right: IOdataField, compare: OdataFilterCompareType) {
    this.field1 = left;
    this.field2 = right;
    this.compare = compare;
  }

  toFilterString() {
    var operator: string;

    if (!this.compare || this.compare === OdataFilterCompareType.Equal) {
      operator = 'eq';
    } else if (this.compare === OdataFilterCompareType.NotEqual) {
      operator = 'ne';
    } else if (this.compare === OdataFilterCompareType.GreaterThan) {
      operator = 'gt';
    } else if (this.compare === OdataFilterCompareType.LessThan) {
      operator = 'lt';
    } else if (this.compare === OdataFilterCompareType.GreaterThanOrEqualTo) {
      operator = 'ge';
    } else if (this.compare === OdataFilterCompareType.LessThanOrEqualTo) {
      operator = 'le';
    } else {
      throw new Error("Bad Odata Filter Compare Type");
    }

    return `${this.field1.toFieldString()} ${operator} ${this.field2.toFieldString()}`;
  }
}

export enum OdataFilterCompareType {
  Equal = 1,
  NotEqual,
  GreaterThan,
  LessThan,
  GreaterThanOrEqualTo,
  LessThanOrEqualTo
}
